import { Map } from 'immutable';
import DatePicker from './component';

const plugin = () => ({
  blockRendererFn: (block, { getProps }) => {
    const { page, readOnly } = getProps();
    const type = block.getType();
    if (type === 'date') {
      return {
        component: DatePicker,
        editable: false,
        props: {
          page,
          readOnly,
        },
      };
    }
    return null;
  },
  // blockStyleFn: (block, { getProps }) => {
  //   const { pageType } = getProps();
  //   const type = block.getType();
  //   if (type === 'date') {
  //     return cx(
  //       // default overwrites
  //       style.container,
  //       pageType === 'artikel' ? style.small : style.wide,
  //       { [style.empty]: block.getText().length === 0 },
  //       { [style.date]: type === 'date' },
  //     );
  //   }
  //   return null;
  // },
  blockRenderMap: Map({
    date: {
      element: 'div',
      props: {},
      caption: true,
      isBlockTypeMutable: false,
      fixed: true,
    },
  }),
});

export default plugin;
